interface Paths { [key: string]: string };
export const pathsEnum: Paths = {
    TIMELINE: "/timeline",
    PUBLICATIONS: "/publications",
    EXPERIENCE: "/experience",
    CONTACT: "/contact",
    PROJECTS: "/projects"
};